import { render, staticRenderFns } from "./ProductsReportTable.vue?vue&type=template&id=5cbd4ac8&scoped=true"
import script from "./ProductsReportTable.vue?vue&type=script&lang=js"
export * from "./ProductsReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd4ac8",
  null
  
)

export default component.exports